var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback-container"},[_c('el-card',{staticClass:"callback-card"},[(_vm.loading)?_c('el-alert',{attrs:{"title":"正在授权登录中...","type":"info","show-icon":""}}):(_vm.error)?_c('el-alert',{attrs:{"title":"授权失败","type":"error","description":_vm.errorMsg,"show-icon":""}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }